<p *ngIf="showPendingRequestsWarning && !showClientFeedbackWarning && !isSearch" class="alert alert-warning">You have at least one unfinished edit request below.  Click <strong>"Finalize edit request"</strong> {{pendingRequestsWarningCopy}}</p>
<p *ngIf="showClientFeedbackWarning && !isSearch" class="alert alert-alert">Your client submitted feedback on at least one piece below. Click <strong>"Finalize edit request"</strong> to send edits to the writer.</p>

<queue-header *ngIf="showCreditInfo && !isSearch && !customer.multipass" [customer]="customer"></queue-header>
<empty-no-requests
  *ngIf="isCustomer && noRequests && noPurchaseableSubmissions"
  [customer]="customer"></empty-no-requests>
<empty-no-queued-submissions
  *ngIf="isCustomer && !noRequests && noPurchaseableSubmissions"
  [customer]="customer"></empty-no-queued-submissions>
<empty-white-label-no-queued-submissions *ngIf="isWhiteLabel && noPurchaseableSubmissions">
</empty-white-label-no-queued-submissions>

<div class="mb-3 d-flex">
  <ng-content *ngIf="(queuedPosts?.length || awaitingAgencyReviewPosts?.length || awaitingEditingSubmissions?.length) && !isSearch" select="[list-top-controls]"></ng-content>
</div>

<video-box *ngFor="let submission of queuedSubmissions; trackBy trackById"
  class="mb-3"
  [submission]="submission"
  (action)="action.emit($event)"
  (accept)="accept.emit($event)"
  (requestEdits)="requestEdits.emit($event)"
></video-box>

<div id="queued-post-list" *ngIf="queuedPosts?.length > 0">
  <h4 *ngIf="isWhiteLabel" class="mt-3">Submissions awaiting your review</h4>
  <div *ngFor="let post of queuedPosts; trackBy trackById" [attr.data-id]="'p_'+post.id" class="mb-3">
    <post-box
      [post]="post"
      [customer]="customer"
      [currentUser]="currentUser"
      [showKeyword]="!isWhiteLabel"
      (deprecatedStoreChange)="deprecatedStoreChange.emit($event)"></post-box>
  </div>
</div>
<div id="awaiting-agency-review-list" *ngIf="isWhiteLabel && awaitingAgencyReviewPosts?.length > 0">
  <h4 class="mt-5">Next steps in progress</h4>
  <div *ngFor="let post of awaitingAgencyReviewPosts; trackBy trackById" [attr.data-id]="'p_'+post.id" class="mb-3">
    <post-box
      [post]="post"
      [customer]="customer"
      [currentUser]="currentUser"
      [showKeyword]="!isWhiteLabel"
      (deprecatedStoreChange)="deprecatedStoreChange.emit($event)"></post-box>
  </div>
</div>

<div *ngIf="showAwaitingEditingSubmissions">
  <h5 class="mt-5 mb-3">
    Editing in progress
    <i class="ml-1 fas fa-question-circle text-dark-blue"
      [popover]="awaitingEditingPopover"
      triggers="mouseenter:mouseleave"
      container="body"></i>
    <ng-template #awaitingEditingPopover>
      <div [style.width]="'300px'">
        These submissions are being edited per your request. You will be notified when editing is complete.
      </div>
    </ng-template>
  </h5>
  <video-box *ngFor="let submission of awaitingEditingSubmissions; trackBy trackById" class="mb-3" [submission]="submission" (action)="action.emit($event)"></video-box>
  <div *ngFor="let post of awaitingEditingPosts; trackBy trackById" class="mb-3">
    <post-box
      [post]="post"
      [customer]="customer"
      [currentUser]="currentUser"
      (deprecatedStoreChange)="deprecatedStoreChange.emit($event)"></post-box>
  </div>
</div>
